import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';
import store from '@/store';
import UserService from '@/services/UserService';
import User from '@/models/User';

@Module({
  namespaced: true,
  name: 'users',
  store,
  dynamic: true,
})
class UserModule extends VuexModule {
  public loggedUser!: User;
  public userToken = localStorage.getItem('clientSetupJWT');
  public service: UserService = new UserService();

  @Action({ rawError: true, commit: 'loginUser' })
  public async authUser(payload: { email: string; password: string }) {
    const res = await this.service.login(payload.email, payload.password);
    if (res.status === 200) {
      localStorage.clientSetupJWT = res.data.token;
      this.getLoggedUser();
      return res.data.token;
    } else {
      throw new Error(`Authentication failed: ${res.data.error}`);
    }
  }

  @Mutation
  public loginUser(token: string) {
    this.userToken = token;
  }

  @Action({ rawError: true, commit: 'loadUser' })
  public async getLoggedUser() {
    let res;
    try {
      if (!localStorage.clientSetupJWT) {
        return new Promise<User>(() => null);
      }
      if (!this.userToken && localStorage.clientSetupJWT) {
        this.setUserToken = localStorage.clientSetupJWT;
      }
      if (this.userToken) {
        res = await this.service.getCurrentUser(this.userToken);
        if (res.status) {
          if (res.status === 200) {
            return { token: this.userToken, user: res.data.user };
          } else if (res.status === 401) {
            localStorage.removeItem('clientSetupJWT');
            this.setUserToken = '';
            return undefined;
          } else {
            return undefined;
          }
        } else {
          localStorage.removeItem('clientSetupJWT');
          this.setUserToken = '';
          return undefined;
        }
      } else {
        return undefined;
      }
    } catch (error) {
      return error;
    }
  }

  @Mutation
  public loadUser(item: any) {
    if (item) {
      this.setUserToken = item.token;
      this.loggedUser = item.user;
    }
  }

  @Action({ rawError: true })
  public async registerUser(payload: {
    email: string;
    password: string;
    role: string;
  }) {
    const res = await this.service.createUser(
      payload.email,
      payload.password,
      payload.role,
    );
    if (res.status === 201) {
      return res.data.user;
    } else {
      throw new Error(`Create new user failed: ${res.data.error}`);
    }
  }

  @Action({ commit: 'loginUser' })
  public async logout() {
    localStorage.removeItem('clientSetupJWT');
    return null;
  }

  get isAuthenticated() {
    return !!this.userToken && !!localStorage.getItem('clientSetupJWT');
  }

  set setUserToken(token: string) {
    this.userToken = token;
  }
}

export default getModule(UserModule);
